export default __webpack_public_path__ + "static/media/africa-map.6ee22ce5.png";